"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var popover_1 = __importDefault(require("@paprika/popover"));
var NavigationButton_styles_1 = __importDefault(require("./NavigationButton.styles"));
function NavigationButton(_a) {
    var ariaLabel = _a.ariaLabel, children = _a.children, className = _a.className, isActive = _a.isActive, onClick = _a.onClick, zIndex = _a.zIndex;
    return (react_1.default.createElement(popover_1.default, { isEager: true, isDark: true, zIndex: zIndex },
        react_1.default.createElement(popover_1.default.Trigger, null, function (handler) { return (react_1.default.createElement(NavigationButton_styles_1.default, { "aria-label": ariaLabel, isActive: isActive, className: className, onMouseOver: handler, onMouseOut: handler, onBlur: handler, onClick: onClick }, children)); }),
        react_1.default.createElement(popover_1.default.Content, null,
            react_1.default.createElement(popover_1.default.Card, null,
                react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: ariaLabel } }))),
        react_1.default.createElement(popover_1.default.Tip, null)));
}
NavigationButton.propTypes = {
    ariaLabel: prop_types_1.default.string.isRequired,
    children: prop_types_1.default.node.isRequired,
    className: prop_types_1.default.string,
    isActive: prop_types_1.default.bool,
    onClick: prop_types_1.default.func.isRequired,
    zIndex: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
};
NavigationButton.defaultProps = {
    className: null,
    isActive: false,
    zIndex: 9999,
};
exports.default = NavigationButton;
//# sourceMappingURL=NavigationButton.js.map